import React, { Component } from 'react';
import { uniqueId } from 'lodash';
import autoBind from 'auto-bind';
import { isValid } from 'date-fns';
import moment from 'moment';
export default class DisputeSubmitForm extends Component {
	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {
            appointmentDate: props.appointmentDetail && props.appointmentDetail.appointmentDate,
            appointmentMode: props.appointmentDetail && props.appointmentDetail.appointmentMode,
            appointmentTime: props.appointmentDetail && props.appointmentDetail.appointmentTime,
            doctorFullName: props.appointmentDetail && props.appointmentDetail.users && props.appointmentDetail.users[0].userName,
            appointmentStatus: props.appointmentDetail && props.appointmentDetail.appointmentStatus,
            appointmentFee: props.appointmentDetail && props.appointmentDetail.fee,
            appointmentId: props.appointmentDetail && props.appointmentDetail._id,
            disputeInput: {
                value: '',
                valid: false,
                message: '',
                isTouched: false
            },
        };
        this.getAppointmentStatus = this.getAppointmentStatus.bind(this);
	}


	// componentDidUpdate(prevProps, prevState) {
	// 	if (
	// 		prevState.value !== this.state.value &&
	// 		typeof this.props.onChange === 'function'
	// 	) {
	// 		this.props.onChange(this.state.value);
    // 	}
    inputOnChange = (e) => {
        this.setState({
            disputeInput: {
                ...this.state.disputeInput,
                value: e.target.value,
                isTouched: true,
                valid: true,
            }
        },()=> {
            if(this.state.disputeInput.value.length <= 0)
            this.setState({disputeInput: {
                ...this.state.disputeInput,
                valid: false,
                isTouched: false,
                message: 'Please state the problem you are having with'
            }})
        })
    }
    submitDisputeForAppointment = () => {
        this.setState({submitted: true})
        // console.log("this.sssss", this.state.disputeInput)
        if(!this.state.disputeInput.valid && !this.state.disputeInput.isTouched ){
            this.setState({disputeInput: {
                ...this.state.disputeInput,
                message: 'Please state the problem you are having with'
            }})
        }else{
            console.log(this.state.disputeInput.value.length)
            if(this.state.disputeInput.value.length <= 0)
            this.setState({disputeInput: {
                ...this.state.disputeInput,
                valid: false,
                isTouched: false,
                message: 'Please state the problem you are having with'
            }})
            else{
                let disputeObject = {
                    subject: this.props.subDisputeDetail.title,
                    description: this.state.disputeInput.value,
                    createdBy: localStorage.getItem('userId'),
                    appointmentId: this.state.appointmentId,
                    subDisputeId: this.props.subDisputeDetail._id
                }
                this.props.submitDispute(disputeObject)
                // console.log("submitted", disputeObject);
            }
        }
    }
    getAppointmentStatus(status) {
        switch (status) {
            case '1': 
                return 'Not Completed'
            case '2': 
                return 'Completed'
            case '3': 
                return 'Doctor Not Shown'
            case '4': 
                return 'Patient Not Shown'
            case '5': 
                return 'Reserved'
            case '6': 
                return 'Cancelled By Doctor'
            case '7': 
                return 'Cancelled By Patient'
        }
    }

	render() {
        let { appointmentDate,
        appointmentMode,
        appointmentTime,
        doctorFullName,
        appointmentStatus,
        appointmentFee, } = this.state;
        // console.log("this.props", this.props)
		return (
            <>
            <div className="appointment-block py-5">
            <div className="row">
                <div className="col-md-6">
                    <span className="item">Appointment Date: {moment(appointmentDate).format('DD-MM-YYYY')}</span>
                </div>
                <div className="col-md-6 text-right">
                    <span className="item">Appointment Time: {appointmentTime}</span>
                </div>
                <div className="col-md-6 ">
                    <span className="item">Doctor Name: {doctorFullName}</span>
                </div>
                <div className="col-md-6 text-right">
                    <span className="item">Appointment Status: {this.getAppointmentStatus(appointmentStatus)}</span>
                </div>
                <div className="col-md-6 ">
                    <span className="item">Consultation Fee: ${appointmentFee}</span>
                </div>
                <div className="col-md-6 text-right">
                    <span className="item">Payment Method: Visa</span>
                </div>
            </div>
        </div>
        <form >
            <div className="form-group">
                <label>Share Details (Required)</label>
                <textarea className="form-control" value={this.state.disputeInput.value} onChange={this.inputOnChange} rows="5" cols="10" placeholder="What went wrong with your appointment or consultation?"></textarea>
                <div>
                {!this.state.disputeInput.valid && !this.state.disputeInput.isTouched && this.state.submitted &&<small className="error"> {this.state.disputeInput.message}</small>}
                </div>
                <div>
                <button type="button" onClick={this.submitDisputeForAppointment} className="searchBTN btn btn-warning">submit</button>
                </div>
            </div>
        </form>
        </>
		);
	}
}